<template>
  <div>
    <slot name="header"></slot>
    <slot>
      <router-view />
    </slot>
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {};
  }
};
</script>
